import React, { useMemo } from 'react'
import saveAs from 'file-saver'
import { toast, type Id } from 'react-toastify'

import NoOp from '../../utils/NoOp'
import links from '../../constants/links'
import {
  type ProductEnum,
  QuotationDocument,
  useGetQuotationDocumentQuery,
} from '../../generated/graphql'
import { useQuotation } from '../context'
import b64toBlob from '../../utils/b64toBlob'
import { PRODUCTS } from '../../constants/products'

import { Checkbox } from '@olino/design-system'

interface Props {
  value?: boolean
  onChange?: (value: boolean) => unknown
  className?: string
}

export const DocumentDownloadText = ({
  name,
  product,
  document,
}: {
  name: string
  product: ProductEnum
  document: QuotationDocument
}) => {
  const { quotation } = useQuotation()

  const [toastId, setToastId] = React.useState<Id | undefined>(undefined)

  const { refetch } = useGetQuotationDocumentQuery(
    {
      quotationId: quotation.id,
      product,
      document,
    },
    {
      enabled: false,

      onSuccess: (data) => {
        if (toastId)
          toast.update(toastId, {
            type: 'info',
            render: `Votre document est prêt`,
            isLoading: false,
            autoClose: 2500,
          })

        saveAs(
          b64toBlob(data.getQuotationDocument, 'application/pdf'),
          `${name} - ${PRODUCTS[product].name}.pdf`
        )
      },
    }
  )

  return (
    <button
      className="font-semibold underline"
      type="button"
      onClick={() => {
        refetch()
        setToastId(toast.loading('Génération du document'))
      }}
    >
      {name}
    </button>
  )
}
